import dayjs from "dayjs";
import environment from "../environments/environment";
const fileBaseUrl = environment.accessDocumentUrl;
export const sum = (a:number, b:number) => {
    return a + b;
};


export const sortbyKeyAsc = (dataSource: any, key: string) => {
    return dataSource.sort((first:any, second: any) => 0 - (first[key] > second[key] ? -1 : 1));
} 

export const sortbyKeyDesc = (dataSource: any, key: string) => {
    return dataSource.sort((first:any, second: any) => 0 - (first[key] > second[key] ? 1 : -1));
} 


export const containsFilter = (value: string,filterText: string) => {
    const valueLowerCase = value ? value.toString().toLowerCase() : '';
    const filterTextLowerCase = filterText ? filterText.toLowerCase() : '';
    return valueLowerCase.indexOf(filterTextLowerCase) >= 0; //contains
}
export const selectionValueDesc = (data: any, type: string) =>{
    return (data || []).map((e: any) => (ddlValueDesc(e,type)));
}

export  const ddlValueDesc = (e: any,type: string) => {    
    let values:any = {};
    const returnVal = {[type] :{
        label:e.title,
        value: e.id, 
        key: e.id, 
        _id: e._id,
        sfdcId:e.sfdcId
    }};
    if(type === 'education'){
        values = {
            ...returnVal, description: e.description, id: e.id,duration_type: e.duration_type,institute: e.institute
        }
        if(e.year_from){
            values['year_from'] = dayjs(new Date(e.year_from));
        }
        if(e.year_to){
            values['year_to'] = dayjs(new Date(e.year_to));
        }
    }
    if(type === 'employment'){
        values = {
            ...returnVal, designation: e.designation, location: e.location, employment_type: e.employment_type, currently_working: e.currently_working, responsibility: e.responsibility, 
            id: e.id
        }
        if(e.year_from){
            values['year_from'] = dayjs(new Date(e.year_from));
        }
        if(e.year_to){
            values['year_to'] = dayjs(new Date(e.year_to));
        }
    }
    if(type === 'certification'){
        values = {
            ...returnVal, description: e.description, id: e.id
        }
        if(e.year_from){
            values['year_from'] = dayjs(new Date(e.year_from));
        }
        if(e.year_to){
            values['year_to'] = dayjs(new Date(e.year_to));
        }

        if(e.valid_till){
            values['valid_till'] = (e.valid_till=='No expiry') ? 'No expiry':dayjs(new Date(e.valid_till)).format('YYYY');
        }
    }
    if(type === 'skill'){
        values = {
            ...returnVal, level: e.level, id: e.id
        }
    }
    if(type === 'language'){
        values = {
            ...returnVal, fluency_level: e.fluency_level, id: e.id
        }
    }
    return values;
}
 
export const formatAddress = (address: any) => {
    if (!address) return '';
    const parts = [
        address.city,
        address.state && address.state.label,
        address.country && address.country.label,
        address.zip
    ].filter((part: any) => !!part);
    return parts.join(', ');
}

export const prepairPictureUrl = (pictureUrl: string) => {
    // if (pictureUrl && pictureUrl.indexOf("http") !== -1) {
    //     console.log(pictureUrl)
    //     return fileBaseUrl + pictureUrl;
    // } else 
    
    if(pictureUrl) {
        return fileBaseUrl + pictureUrl
    } else {
        return 'https://den.serviceo.me/api/v1/Containers/profile-images/download/5c9e11c7-b95d-486b-8740-f413b35430cc.png'
    }
}

const COUNTRY_NAME_TO_CODE: Record<string, string> = {
    'afghanistan': 'AFG', 'albania': 'ALB', 'algeria': 'DZA', 'argentina': 'ARG',
    'australia': 'AUS', 'austria': 'AUT', 'bahrain': 'BHR', 'bangladesh': 'BGD',
    'belgium': 'BEL', 'brazil': 'BRA', 'canada': 'CAN', 'chile': 'CHL',
    'china': 'CHN', "people's republic of china": 'CHN', 'colombia': 'COL',
    'croatia': 'HRV', 'czech republic': 'CZE', 'czechia': 'CZE', 'denmark': 'DNK',
    'egypt': 'EGY', 'ethiopia': 'ETH', 'finland': 'FIN', 'france': 'FRA',
    'germany': 'DEU', 'ghana': 'GHA', 'greece': 'GRC', 'hong kong': 'HKG',
    'hungary': 'HUN', 'india': 'IND', 'indonesia': 'IDN', 'iran': 'IRN',
    'iraq': 'IRQ', 'ireland': 'IRL', 'israel': 'ISR', 'italy': 'ITA',
    'japan': 'JPN', 'jordan': 'JOR', 'kenya': 'KEN', 'kuwait': 'KWT',
    'malaysia': 'MYS', 'mexico': 'MEX', 'morocco': 'MAR', 'netherlands': 'NLD',
    'new zealand': 'NZL', 'nigeria': 'NGA', 'norway': 'NOR', 'oman': 'OMN',
    'pakistan': 'PAK', 'peru': 'PER', 'philippines': 'PHL', 'poland': 'POL',
    'portugal': 'PRT', 'qatar': 'QAT', 'romania': 'ROU', 'russia': 'RUS',
    'russian federation': 'RUS', 'saudi arabia': 'SAU', 'singapore': 'SGP',
    'south africa': 'ZAF', 'south korea': 'KOR', 'republic of korea': 'KOR',
    'spain': 'ESP', 'sri lanka': 'LKA', 'sweden': 'SWE', 'switzerland': 'CHE',
    'taiwan': 'TWN', 'thailand': 'THA', 'turkey': 'TUR', 'türkiye': 'TUR',
    'ukraine': 'UKR', 'united arab emirates': 'ARE', 'uae': 'ARE',
    'united kingdom': 'GBR', 'uk': 'GBR', 'great britain': 'GBR',
    'united states': 'USA', 'united states of america': 'USA', 'us': 'USA', 'usa': 'USA',
    'vietnam': 'VNM', 'viet nam': 'VNM', 'zimbabwe': 'ZWE',
};

const COUNTRY_ALPHA2_TO_ALPHA3: Record<string, string> = {
    'AF': 'AFG', 'AL': 'ALB', 'DZ': 'DZA', 'AR': 'ARG', 'AU': 'AUS', 'AT': 'AUT',
    'BH': 'BHR', 'BD': 'BGD', 'BE': 'BEL', 'BR': 'BRA', 'CA': 'CAN', 'CL': 'CHL',
    'CN': 'CHN', 'CO': 'COL', 'HR': 'HRV', 'CZ': 'CZE', 'DK': 'DNK', 'EG': 'EGY',
    'ET': 'ETH', 'FI': 'FIN', 'FR': 'FRA', 'DE': 'DEU', 'GH': 'GHA', 'GR': 'GRC',
    'HK': 'HKG', 'HU': 'HUN', 'IN': 'IND', 'ID': 'IDN', 'IR': 'IRN', 'IQ': 'IRQ',
    'IE': 'IRL', 'IL': 'ISR', 'IT': 'ITA', 'JP': 'JPN', 'JO': 'JOR', 'KE': 'KEN',
    'KW': 'KWT', 'MY': 'MYS', 'MX': 'MEX', 'MA': 'MAR', 'NL': 'NLD', 'NZ': 'NZL',
    'NG': 'NGA', 'NO': 'NOR', 'OM': 'OMN', 'PK': 'PAK', 'PE': 'PER', 'PH': 'PHL',
    'PL': 'POL', 'PT': 'PRT', 'QA': 'QAT', 'RO': 'ROU', 'RU': 'RUS', 'SA': 'SAU',
    'SG': 'SGP', 'ZA': 'ZAF', 'KR': 'KOR', 'ES': 'ESP', 'LK': 'LKA', 'SE': 'SWE',
    'CH': 'CHE', 'TW': 'TWN', 'TH': 'THA', 'TR': 'TUR', 'UA': 'UKR', 'AE': 'ARE',
    'GB': 'GBR', 'UK': 'GBR', 'US': 'USA', 'VN': 'VNM', 'ZW': 'ZWE',
};

export const expandCountryToCodeAndName = (value: string): string[] => {
    if (!value) return [];
    const trimmed = value.trim();
    const isCode = trimmed.length === 3 && trimmed === trimmed.toUpperCase();
    if (isCode) return [trimmed];
    const alpha3 = COUNTRY_ALPHA2_TO_ALPHA3[trimmed.toUpperCase()];
    if (trimmed.length === 2 && alpha3) return [trimmed, alpha3];
    const code = COUNTRY_NAME_TO_CODE[trimmed.toLowerCase()];
    return code ? [trimmed, code] : [trimmed];
};

export const phoneRegexValidation = (value: any) => {
    const regex = /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?([-]?[\s]?[0-9])+$/i;
    return !(!value || regex.test(value) === false)
}

export const passwordRegexValidation = (value: any) => {
    // Minimum eight characters, at least one letter, one number and one special character:
    const regex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{10,}$/
    return regex.test(value);
}

export const phoneRegexValidationIndia = (value: any) => {
    //digit and +
    const regex = /^((\+91?)|\+)?[7-9][0-9]{9}$/
    return regex.test(value);
}